import FacilityEdit from './FacilityEdit'

export default FacilityEdit;